import { ComponentInstall } from "../../utils";
import DropdownMenu from "./src";

export default ComponentInstall(DropdownMenu);
